import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function RatingThumbsDownIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Rating Thumbs Down</title>
      <g>
        <path d="M37.3895 7.5H16.9349C15.0486 7.5 13.4349 8.625 12.7531 10.245L5.88947 26.1075C5.68493 26.625 5.57129 27.165 5.57129 27.75V32.25C5.57129 34.725 7.61674 36.75 10.1167 36.75H24.4577L22.2986 47.0325L22.2304 47.7525C22.2304 48.675 22.6167 49.53 23.2304 50.1375L25.6395 52.5L40.6167 37.6725C41.4349 36.8625 41.9349 35.7375 41.9349 34.5V12C41.9349 9.525 39.8895 7.5 37.3895 7.5ZM46.4804 7.5V34.5H55.5713V7.5H46.4804Z" />
      </g>
    </SvgIcon>
  );
}

export default RatingThumbsDownIcon;
